import { doc, setDoc } from "firebase/firestore";
import { firestore as db } from "../backend/firebaseconfig";
import { subscribeAdviserFullDetailsByEmailOrId } from "./UserLiveDetails";

export const getAdviserDocPaths = (adviserId) => {
  if (!adviserId) {
    throw new Error("Adviser id is required.");
  }

  return {
    adviserRef: doc(db, "Authorized Members", "Advisers", "Data", adviserId),

    personalDetailsRef: doc(
      db,
      "Authorized Members",
      "Advisers",
      "Data",
      adviserId,
      "Personal Details",
      "Data",
    ),

    applicationDetailsRef: doc(
      db,
      "Authorized Members",
      "Advisers",
      "Data",
      adviserId,
      "Application Details",
      "Data",
    ),

    nextOfKinRef: doc(
      db,
      "Authorized Members",
      "Advisers",
      "Data",
      adviserId,
      "Application Details",
      "Next of Kin Details",
    ),
  };
};

export const buildEditAdviserForm = (data = {}) => ({
  adviserDoc: data?.adviserDoc || {},
  personalDetails: data?.personalDetails || {},
  applicationDetails: data?.applicationDetails || {},
  nextOfKinDetails: data?.nextOfKinDetails || {},
});

export const subscribeEditAdviserForm = (adviserKey, callback) => {
  return subscribeAdviserFullDetailsByEmailOrId(adviserKey, (data) => {
    callback({
      details: data,
      form: buildEditAdviserForm(data),
    });
  });
};

export const saveEditAdviserForm = async (adviserId, form = {}) => {
  const {
    adviserRef,
    personalDetailsRef,
    applicationDetailsRef,
    nextOfKinRef,
  } = getAdviserDocPaths(adviserId);

  await Promise.all([
    setDoc(adviserRef, form.adviserDoc || {}, { merge: true }),
    setDoc(personalDetailsRef, form.personalDetails || {}, { merge: true }),
    setDoc(applicationDetailsRef, form.applicationDetails || {}, {
      merge: true,
    }),
    setDoc(nextOfKinRef, form.nextOfKinDetails || {}, { merge: true }),
  ]);
};
